import React, {
  useState,
  type FC,
  type InputHTMLAttributes,
  type ChangeEventHandler,
  useCallback,
} from 'react'
import clsx from 'clsx'
import { SmallCrossIcon } from '../Icons'
import styles from './input.scss'

export type InputProps = {
  label?: string
  withClear?: boolean
  className?: string
  onUserChange?: (value: string) => void
  isWarn?: (val: string) => boolean
} & InputHTMLAttributes<HTMLInputElement>

export const Input: FC<InputProps> = (props) => {
  const {
    label,
    className,
    withClear = false,
    isWarn,
    onUserChange,
    value,
    ...otherProps
  } = props
  const [warn, setWarn] = useState(false)

  const handleChange: ChangeEventHandler<HTMLInputElement> = (e) => {
    const val = e.target.value
    if(isWarn?.(val)) {
      setWarn(true)
    } else {
      setWarn(false)
    }
    onUserChange?.(val)
  }

  const handleClear = useCallback(() => {
    onUserChange?.('')
  }, [])

  return (
    <div className={clsx(styles.container, className)}>
      {label && <label className={styles.labelClass}>{label}</label>}
      <input
        className={clsx(
          styles.inputClass,
          withClear && styles['inputClass--withClear'],
          warn && styles.warning,
        )}
        value={value}
        {...otherProps}
        onChange={handleChange}
      />
      {withClear && (
        <div
          className={clsx(styles.clear, String(value ?? '').length > 0 && styles['clear--active'])}
          onClick={handleClear}
          role="button"
        >
          <SmallCrossIcon />
        </div>
      )}
    </div>
  )
}
